export const funcUrlDel = (name) => {
  const loca = window.location
  const baseUrl = loca.origin + loca.pathname + "?"
  const query = loca.search.substr(1)

  if (query.indexOf(name) > -1) {
      let obj = {}
      let arr = query.split("&")

      for (var i = 0; i < arr.length; i++) {
          arr[i] = arr[i].split("=")
          obj[arr[i][0]] = arr[i][1]
      }
      delete obj[name]

      const url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&")
      return url
  } else {
    return loca.href
  }
}


// WEBPACK FOOTER //
// ./src/lib/utils.js